export default function AgencyMission() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <div className="bg-gray-50 rounded-3xl p-12 border border-gray-200">
          <p className="font-inter text-lg text-gray-700 leading-relaxed mb-8">
            Based in Charleston, Illinois, LaCrue Digital Agency works with business owners nationwide who value professionalism, speed, and results.
          </p>
          <p className="font-inter text-lg text-gray-700 leading-relaxed mb-10">
            If you're ready to upgrade your online presence, we're ready to build it.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => {
                const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
                if (widget) widget.click();
              }}
              className="bg-primary text-white px-8 py-4 rounded-xl font-inter font-medium text-base hover:bg-primary/90 transition-colors whitespace-nowrap cursor-pointer"
            >
              Book a Call
            </button>
            <a
              href="/contact"
              className="border-2 border-primary text-primary px-8 py-4 rounded-xl font-inter font-medium text-base hover:bg-primary hover:text-white transition-colors whitespace-nowrap cursor-pointer text-center"
            >
              Get in Touch
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}